import { render, staticRenderFns } from "./FormOrganizationCredentials.vue?vue&type=template&id=4e87e380&"
import script from "./FormOrganizationCredentials.vue?vue&type=script&lang=js&"
export * from "./FormOrganizationCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports